import Vue from 'vue';
import Vuex from 'vuex';

import application from '../../application';
import msal from '../../msal';
import user from '../../user';

import base from './base';

import brk from '../../brk-v2';
import usage from '../../usage';
import geo from '../../geo';
import accessibility from '../../accessibility';

// TODO make action for getdata in application and use it in print
import print from '../../print';

const actions = {
    ...application.actions,
    ...msal.actions,
    ...geo.actions,
    ...accessibility.actions,
    ...user.actions,
    ...base.actions,
    ...brk.actions,
    ...usage.actions,
    ...print.actions
};
const getters = {
    ...application.getters,
    ...msal.getters,
    ...geo.getters,
    ...accessibility.getters,
    ...user.getters,
    ...base.getters,
    ...brk.getters,
    ...usage.getters,
    ...print.getters
};
const mutations = {
    ...application.mutations,
    ...msal.mutations,
    ...geo.mutations,
    ...accessibility.mutations,
    ...user.mutations,
    ...base.mutations,
    ...brk.mutations,
    ...usage.mutations,
    ...print.mutations
};
const state = {
    ...application.state,
    ...msal.state,
    ...geo.state,
    ...accessibility.state,
    ...user.state,
    ...base.state,
    ...brk.state,
    ...usage.state,
    ...print.state
};


Vue.use(Vuex);

const store = new Vuex.Store({
    state,

    mutations,

    actions,

    getters

});

export default store;
